/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsUrlOpenMethod } from './FxIdDomainSettingsUrlOpenMethod';
import {
    FxIdDomainSettingsUrlOpenMethodFromJSON,
    FxIdDomainSettingsUrlOpenMethodFromJSONTyped,
    FxIdDomainSettingsUrlOpenMethodToJSON,
    FxIdDomainSettingsUrlOpenMethodToJSONTyped,
} from './FxIdDomainSettingsUrlOpenMethod';
import type { FxIdWebFeaturesPlayGameResponseLaunchData } from './FxIdWebFeaturesPlayGameResponseLaunchData';
import {
    FxIdWebFeaturesPlayGameResponseLaunchDataFromJSON,
    FxIdWebFeaturesPlayGameResponseLaunchDataFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseLaunchDataToJSON,
    FxIdWebFeaturesPlayGameResponseLaunchDataToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseLaunchData';
import type { FxIdDomainSettingsEGameOrientation } from './FxIdDomainSettingsEGameOrientation';
import {
    FxIdDomainSettingsEGameOrientationFromJSON,
    FxIdDomainSettingsEGameOrientationFromJSONTyped,
    FxIdDomainSettingsEGameOrientationToJSON,
    FxIdDomainSettingsEGameOrientationToJSONTyped,
} from './FxIdDomainSettingsEGameOrientation';
import type { FxIdApplicationPublicDataBuilderPlatformDataOptions } from './FxIdApplicationPublicDataBuilderPlatformDataOptions';
import {
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptions';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation } from './FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions';
import type { FxIdDomainSettingsPublicWebClientConfigOptions } from './FxIdDomainSettingsPublicWebClientConfigOptions';
import {
    FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsToJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsToJSONTyped,
} from './FxIdDomainSettingsPublicWebClientConfigOptions';
import type { FxIdWebFeaturesPlayGameResponseIframeGame } from './FxIdWebFeaturesPlayGameResponseIframeGame';
import {
    FxIdWebFeaturesPlayGameResponseIframeGameFromJSON,
    FxIdWebFeaturesPlayGameResponseIframeGameFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseIframeGameToJSON,
    FxIdWebFeaturesPlayGameResponseIframeGameToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseIframeGame';
import type { FxIdWebFeaturesPlayGameResponseUnityGameConfig } from './FxIdWebFeaturesPlayGameResponseUnityGameConfig';
import {
    FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSON,
    FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSONTyped,
    FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSON,
    FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSONTyped,
} from './FxIdWebFeaturesPlayGameResponseUnityGameConfig';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseSupport } from './FxIdApplicationPublicDataBuilderPublicDataBaseSupport';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseSupport';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseAuth } from './FxIdApplicationPublicDataBuilderPublicDataBaseAuth';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseAuth';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions';
import type { FxIdDomainEntitiesPlayGameType } from './FxIdDomainEntitiesPlayGameType';
import {
    FxIdDomainEntitiesPlayGameTypeFromJSON,
    FxIdDomainEntitiesPlayGameTypeFromJSONTyped,
    FxIdDomainEntitiesPlayGameTypeToJSON,
    FxIdDomainEntitiesPlayGameTypeToJSONTyped,
} from './FxIdDomainEntitiesPlayGameType';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions';
import type { FxIdApplicationPublicDataBuilderPublicDataBasePresentation } from './FxIdApplicationPublicDataBuilderPublicDataBasePresentation';
import {
    FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBasePresentation';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseStatistics } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatistics';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStatistics';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesPlayGameResponse
 */
export interface FxIdWebFeaturesPlayGameResponse {
    /**
     * 
     * @type {FxIdDomainEntitiesPlayGameType}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    PlayGameType: FxIdDomainEntitiesPlayGameType;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPlatformDataOptions}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    PlatformData: FxIdApplicationPublicDataBuilderPlatformDataOptions;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseStatistics}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    Statistics?: FxIdApplicationPublicDataBuilderPublicDataBaseStatistics | null;
    /**
     * 
     * @type {FxIdDomainSettingsEGameOrientation}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    GameOrientation: FxIdDomainSettingsEGameOrientation;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation}
     * @memberof FxIdWebFeaturesPlayGameResponse
     * @deprecated
     */
    MobileGameOrientation: FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBasePresentation}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    Presentation?: FxIdApplicationPublicDataBuilderPublicDataBasePresentation | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBasePresentation}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    MobilePresentation?: FxIdApplicationPublicDataBuilderPublicDataBasePresentation | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBasePresentation}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    ViewportPresentation?: FxIdApplicationPublicDataBuilderPublicDataBasePresentation | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    SupportedLanguages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    DefaultLanguage: string;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseSupport}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    Support?: FxIdApplicationPublicDataBuilderPublicDataBaseSupport | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    Store: FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    FxLauncherOptions?: FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    Turnstile: FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptions;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    CompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    TosUrl: string;
    /**
     * 
     * @type {FxIdDomainSettingsUrlOpenMethod}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    TosUrlOpenMethod: FxIdDomainSettingsUrlOpenMethod;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    PpUrl: string;
    /**
     * 
     * @type {FxIdDomainSettingsUrlOpenMethod}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    PpUrlOpenMethod: FxIdDomainSettingsUrlOpenMethod;
    /**
     * 
     * @type {FxIdDomainSettingsPublicWebClientConfigOptions}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    PublicWebClientConfig: FxIdDomainSettingsPublicWebClientConfigOptions;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseAuth}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    Auth?: FxIdApplicationPublicDataBuilderPublicDataBaseAuth | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    GameSystemName: string;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    NamespacedProductsL10N: boolean;
    /**
     * Эффективный неймспейс для ключей локализации продуктов (LocaleNamespace ?? GameSystemName).
     * null если неймспейсинг выключен
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    ProductL10NNamespace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    GameJwt: string;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseUnityGameConfig}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    UnityGameConfig?: FxIdWebFeaturesPlayGameResponseUnityGameConfig | null;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseIframeGame}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    IframeGame?: FxIdWebFeaturesPlayGameResponseIframeGame | null;
    /**
     * 
     * @type {FxIdWebFeaturesPlayGameResponseLaunchData}
     * @memberof FxIdWebFeaturesPlayGameResponse
     */
    LaunchData?: FxIdWebFeaturesPlayGameResponseLaunchData | null;
}



/**
 * Check if a given object implements the FxIdWebFeaturesPlayGameResponse interface.
 */
export function instanceOfFxIdWebFeaturesPlayGameResponse(value: object): value is FxIdWebFeaturesPlayGameResponse {
    if (!('PlayGameType' in value) || value['PlayGameType'] === undefined) return false;
    if (!('PlatformData' in value) || value['PlatformData'] === undefined) return false;
    if (!('GameOrientation' in value) || value['GameOrientation'] === undefined) return false;
    if (!('MobileGameOrientation' in value) || value['MobileGameOrientation'] === undefined) return false;
    if (!('SupportedLanguages' in value) || value['SupportedLanguages'] === undefined) return false;
    if (!('DefaultLanguage' in value) || value['DefaultLanguage'] === undefined) return false;
    if (!('Store' in value) || value['Store'] === undefined) return false;
    if (!('Turnstile' in value) || value['Turnstile'] === undefined) return false;
    if (!('CompanyName' in value) || value['CompanyName'] === undefined) return false;
    if (!('TosUrl' in value) || value['TosUrl'] === undefined) return false;
    if (!('TosUrlOpenMethod' in value) || value['TosUrlOpenMethod'] === undefined) return false;
    if (!('PpUrl' in value) || value['PpUrl'] === undefined) return false;
    if (!('PpUrlOpenMethod' in value) || value['PpUrlOpenMethod'] === undefined) return false;
    if (!('PublicWebClientConfig' in value) || value['PublicWebClientConfig'] === undefined) return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    if (!('NamespacedProductsL10N' in value) || value['NamespacedProductsL10N'] === undefined) return false;
    if (!('GameJwt' in value) || value['GameJwt'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesPlayGameResponseFromJSON(json: any): FxIdWebFeaturesPlayGameResponse {
    return FxIdWebFeaturesPlayGameResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeFromJSON(json['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsFromJSON(json['PlatformData']),
        'Statistics': json['Statistics'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsFromJSON(json['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationFromJSON(json['GameOrientation']),
        'MobileGameOrientation': FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSON(json['MobileGameOrientation']),
        'Presentation': json['Presentation'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json['Presentation']),
        'MobilePresentation': json['MobilePresentation'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json['MobilePresentation']),
        'ViewportPresentation': json['ViewportPresentation'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBasePresentationFromJSON(json['ViewportPresentation']),
        'SupportedLanguages': json['SupportedLanguages'],
        'DefaultLanguage': json['DefaultLanguage'],
        'Support': json['Support'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseSupportFromJSON(json['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON(json['Store']),
        'FxLauncherOptions': json['FxLauncherOptions'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSON(json['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsFromJSON(json['Turnstile']),
        'CompanyName': json['CompanyName'],
        'TosUrl': json['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['TosUrlOpenMethod']),
        'PpUrl': json['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodFromJSON(json['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsFromJSON(json['PublicWebClientConfig']),
        'Auth': json['Auth'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseAuthFromJSON(json['Auth']),
        'GameSystemName': json['GameSystemName'],
        'NamespacedProductsL10N': json['NamespacedProductsL10N'],
        'ProductL10NNamespace': json['ProductL10NNamespace'] == null ? undefined : json['ProductL10NNamespace'],
        'GameJwt': json['GameJwt'],
        'UnityGameConfig': json['UnityGameConfig'] == null ? undefined : FxIdWebFeaturesPlayGameResponseUnityGameConfigFromJSON(json['UnityGameConfig']),
        'IframeGame': json['IframeGame'] == null ? undefined : FxIdWebFeaturesPlayGameResponseIframeGameFromJSON(json['IframeGame']),
        'LaunchData': json['LaunchData'] == null ? undefined : FxIdWebFeaturesPlayGameResponseLaunchDataFromJSON(json['LaunchData']),
    };
}

export function FxIdWebFeaturesPlayGameResponseToJSON(json: any): FxIdWebFeaturesPlayGameResponse {
    return FxIdWebFeaturesPlayGameResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseToJSONTyped(value?: FxIdWebFeaturesPlayGameResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PlayGameType': FxIdDomainEntitiesPlayGameTypeToJSON(value['PlayGameType']),
        'PlatformData': FxIdApplicationPublicDataBuilderPlatformDataOptionsToJSON(value['PlatformData']),
        'Statistics': FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsToJSON(value['Statistics']),
        'GameOrientation': FxIdDomainSettingsEGameOrientationToJSON(value['GameOrientation']),
        'MobileGameOrientation': FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSON(value['MobileGameOrientation']),
        'Presentation': FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(value['Presentation']),
        'MobilePresentation': FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(value['MobilePresentation']),
        'ViewportPresentation': FxIdApplicationPublicDataBuilderPublicDataBasePresentationToJSON(value['ViewportPresentation']),
        'SupportedLanguages': value['SupportedLanguages'],
        'DefaultLanguage': value['DefaultLanguage'],
        'Support': FxIdApplicationPublicDataBuilderPublicDataBaseSupportToJSON(value['Support']),
        'Store': FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON(value['Store']),
        'FxLauncherOptions': FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSON(value['FxLauncherOptions']),
        'Turnstile': FxIdApplicationPublicDataBuilderPublicDataBaseTurnstileOptionsToJSON(value['Turnstile']),
        'CompanyName': value['CompanyName'],
        'TosUrl': value['TosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['TosUrlOpenMethod']),
        'PpUrl': value['PpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsUrlOpenMethodToJSON(value['PpUrlOpenMethod']),
        'PublicWebClientConfig': FxIdDomainSettingsPublicWebClientConfigOptionsToJSON(value['PublicWebClientConfig']),
        'Auth': FxIdApplicationPublicDataBuilderPublicDataBaseAuthToJSON(value['Auth']),
        'GameSystemName': value['GameSystemName'],
        'NamespacedProductsL10N': value['NamespacedProductsL10N'],
        'ProductL10NNamespace': value['ProductL10NNamespace'],
        'GameJwt': value['GameJwt'],
        'UnityGameConfig': FxIdWebFeaturesPlayGameResponseUnityGameConfigToJSON(value['UnityGameConfig']),
        'IframeGame': FxIdWebFeaturesPlayGameResponseIframeGameToJSON(value['IframeGame']),
        'LaunchData': FxIdWebFeaturesPlayGameResponseLaunchDataToJSON(value['LaunchData']),
    };
}

